import { gsap } from 'gsap';
import { carousel } from '../components/carousel';
import { mq } from '../util/matchMedia';

// GLOSSARY:
// -> Gallery: the section of the site
// -> Collection: each set of 6 media items within the Gallery section
// -> Carousel: the automated transition between Collections

export const animateIn = (() => {
  let tl, logo, nav;

  const init = () => {
    getReferenceElements();
    buildTimeline();
    tl.play();
    carousel.play();
  }

  const getReferenceElements = () => {
    logo = document.querySelector('.js-navigation-logo');
    nav = document.querySelector('.js-navigation');
  }

  const buildTimeline = () => {
    tl = gsap.timeline({ paused: true });
    tl.set(nav, { autoAlpha: 1 }, 0);

    if (mq.isDesktop) {
      tl.set(logo, { autoAlpha: 1 }, 0);
    }
  }

  const destroy = () => tl = null;

  return { init, destroy };
})();
